var map = {
	"./1": 158,
	"./1.png": 158,
	"./2": 159,
	"./2.png": 159,
	"./3": 160,
	"./3.png": 160,
	"./4": 161,
	"./4.png": 161,
	"./about": 162,
	"./about.png": 162,
	"./activity": 275,
	"./activity.svg": 275,
	"./add-cta": 356,
	"./add-cta-active": 357,
	"./add-cta-active.svg": 357,
	"./add-cta.svg": 356,
	"./added-to-collections-active": 358,
	"./added-to-collections-active.svg": 358,
	"./adobe": 163,
	"./adobe.png": 163,
	"./analytics": 359,
	"./analytics.svg": 359,
	"./annotate": 360,
	"./annotate-active": 361,
	"./annotate-active.svg": 361,
	"./annotate.svg": 360,
	"./annotate/arrow": 318,
	"./annotate/arrow.svg": 318,
	"./annotate/crop": 319,
	"./annotate/crop.svg": 319,
	"./annotate/draw": 320,
	"./annotate/draw.svg": 320,
	"./annotate/ellipse": 321,
	"./annotate/ellipse-focus": 322,
	"./annotate/ellipse-focus.svg": 322,
	"./annotate/ellipse.svg": 321,
	"./annotate/emoji": 145,
	"./annotate/emoji.png": 145,
	"./annotate/emoji@2x": 146,
	"./annotate/emoji@2x.png": 146,
	"./annotate/emoji@3x": 147,
	"./annotate/emoji@3x.png": 147,
	"./annotate/highlighter": 323,
	"./annotate/highlighter.svg": 323,
	"./annotate/line": 324,
	"./annotate/line.svg": 324,
	"./annotate/number": 325,
	"./annotate/number.svg": 325,
	"./annotate/pixelate": 326,
	"./annotate/pixelate.svg": 326,
	"./annotate/rect": 327,
	"./annotate/rect.svg": 327,
	"./annotate/square-focus": 328,
	"./annotate/square-focus.svg": 328,
	"./annotate/text": 329,
	"./annotate/text.svg": 329,
	"./annotate/tools-history-back": 330,
	"./annotate/tools-history-back-disabled": 331,
	"./annotate/tools-history-back-disabled.svg": 331,
	"./annotate/tools-history-back.svg": 330,
	"./annotate/tools-history-forward": 332,
	"./annotate/tools-history-forward-disabled": 333,
	"./annotate/tools-history-forward-disabled.svg": 333,
	"./annotate/tools-history-forward.svg": 332,
	"./annotate/tools-zoom-zoom-in": 314,
	"./annotate/tools-zoom-zoom-in.svg": 314,
	"./annotate/tools-zoom-zoom-out": 315,
	"./annotate/tools-zoom-zoom-out.svg": 315,
	"./app-icon": 362,
	"./app-icon.svg": 362,
	"./apple": 363,
	"./apple.svg": 363,
	"./apple_logo": 262,
	"./apple_logo.svg": 262,
	"./arrow-big": 164,
	"./arrow-big.png": 164,
	"./atlassian": 165,
	"./atlassian.png": 165,
	"./bg-bottom": 166,
	"./bg-bottom.png": 166,
	"./bg-top": 167,
	"./bg-top.png": 167,
	"./bill": 364,
	"./bill.svg": 364,
	"./blurred-drop": 112,
	"./blurred-drop.png": 112,
	"./branding": 316,
	"./branding.svg": 316,
	"./buttons-add-new-collection-hover": 365,
	"./buttons-add-new-collection-hover.svg": 365,
	"./buttons-add-new-collection-sidebar": 366,
	"./buttons-add-new-collection-sidebar.svg": 366,
	"./card-generic": 136,
	"./card-generic.png": 136,
	"./check-mark": 367,
	"./check-mark.svg": 367,
	"./checkmark": 368,
	"./checkmark.svg": 368,
	"./checkmark@2x": 168,
	"./checkmark@2x.png": 168,
	"./chrome": 369,
	"./chrome.svg": 369,
	"./close": 336,
	"./close-icon": 218,
	"./close-icon.svg": 218,
	"./close.svg": 336,
	"./cloud-loader": 298,
	"./cloud-loader.gif": 298,
	"./cloudapp": 120,
	"./cloudapp-favicon": 169,
	"./cloudapp-favicon.png": 169,
	"./cloudapp-icon": 170,
	"./cloudapp-icon.png": 170,
	"./cloudapp-logo-horizontal": 243,
	"./cloudapp-logo-horizontal.svg": 243,
	"./cloudapp.png": 120,
	"./coach-mark": 370,
	"./coach-mark.svg": 370,
	"./collection": 244,
	"./collection.svg": 244,
	"./conversation": 371,
	"./conversation.svg": 371,
	"./dashboard": 276,
	"./dashboard.svg": 276,
	"./download-arrow": 372,
	"./download-arrow.svg": 372,
	"./download-chrome": 373,
	"./download-chrome.svg": 373,
	"./download-cloud": 374,
	"./download-cloud.svg": 374,
	"./download-drop": 375,
	"./download-drop.svg": 375,
	"./download-mac": 376,
	"./download-mac.svg": 376,
	"./download-windows": 377,
	"./download-windows.svg": 377,
	"./download_icon_chrome": 378,
	"./download_icon_chrome.svg": 378,
	"./download_icon_mac": 379,
	"./download_icon_mac.svg": 379,
	"./download_icon_windows": 380,
	"./download_icon_windows.svg": 380,
	"./email": 263,
	"./email.svg": 263,
	"./enterprise@2x": 171,
	"./enterprise@2x.png": 171,
	"./file-placeholder": 334,
	"./file-placeholder.svg": 334,
	"./free@2x": 172,
	"./free@2x.png": 172,
	"./free_plan_icon": 173,
	"./free_plan_icon.png": 173,
	"./gift": 299,
	"./gift.svg": 299,
	"./google_logo": 381,
	"./google_logo.svg": 381,
	"./hat-icon": 382,
	"./hat-icon.svg": 382,
	"./hero-asset": 121,
	"./hero-asset.gif": 577,
	"./hero-asset.png": 121,
	"./icon-clock": 264,
	"./icon-clock.jpeg": 264,
	"./icon-get-cloudapp": 219,
	"./icon-get-cloudapp.svg": 219,
	"./icon-google": 265,
	"./icon-google.svg": 265,
	"./icon-muted": 335,
	"./icon-muted.svg": 335,
	"./icon-muted@2x": 174,
	"./icon-muted@2x.png": 174,
	"./icon-padlock": 220,
	"./icon-padlock.svg": 220,
	"./icons-add": 300,
	"./icons-add-bordered": 175,
	"./icons-add-bordered.png": 175,
	"./icons-add-to-collection-solid": 383,
	"./icons-add-to-collection-solid.svg": 383,
	"./icons-add.svg": 300,
	"./icons-announcement": 384,
	"./icons-announcement.svg": 384,
	"./icons-bug": 385,
	"./icons-bug.svg": 385,
	"./icons-card-actions-compact-read-only": 137,
	"./icons-card-actions-compact-read-only.svg": 137,
	"./icons-clipboard": 284,
	"./icons-clipboard-2": 285,
	"./icons-clipboard-2.svg": 285,
	"./icons-clipboard.svg": 284,
	"./icons-close": 313,
	"./icons-close.svg": 313,
	"./icons-conversation": 142,
	"./icons-conversation.svg": 142,
	"./icons-download-bordered": 176,
	"./icons-download-bordered.png": 176,
	"./icons-download-solid": 386,
	"./icons-download-solid.svg": 386,
	"./icons-edit-minimal": 266,
	"./icons-edit-minimal.svg": 266,
	"./icons-embed-bordered": 177,
	"./icons-embed-bordered.png": 177,
	"./icons-embed-solid": 387,
	"./icons-embed-solid.svg": 387,
	"./icons-hidden": 388,
	"./icons-hidden.svg": 388,
	"./icons-invite-active": 277,
	"./icons-invite-active.svg": 277,
	"./icons-invite-default": 278,
	"./icons-invite-default.svg": 278,
	"./icons-locked-bordered": 178,
	"./icons-locked-bordered.png": 178,
	"./icons-magic": 389,
	"./icons-magic.svg": 389,
	"./icons-mouse-click": 390,
	"./icons-mouse-click-gray": 391,
	"./icons-mouse-click-gray.svg": 391,
	"./icons-mouse-click.svg": 390,
	"./icons-new": 179,
	"./icons-new-gray": 301,
	"./icons-new-gray.svg": 301,
	"./icons-new-transparent": 302,
	"./icons-new-transparent.svg": 302,
	"./icons-new-white": 303,
	"./icons-new-white.svg": 303,
	"./icons-new.svg": 179,
	"./icons-notifications": 143,
	"./icons-notifications-active": 144,
	"./icons-notifications-active.svg": 144,
	"./icons-notifications.svg": 143,
	"./icons-premium-star": 304,
	"./icons-premium-star.svg": 304,
	"./icons-rainbow-circle": 180,
	"./icons-rainbow-circle.png": 180,
	"./icons-rounded-corners": 392,
	"./icons-rounded-corners.svg": 392,
	"./icons-sales": 393,
	"./icons-sales.svg": 393,
	"./icons-search": 394,
	"./icons-search.svg": 394,
	"./icons-settings-blue": 305,
	"./icons-settings-blue.svg": 305,
	"./icons-settings-gray": 267,
	"./icons-settings-gray.svg": 267,
	"./icons-share-settings-locked": 395,
	"./icons-share-settings-locked.svg": 395,
	"./icons-slightly-rounded-corners": 396,
	"./icons-slightly-rounded-corners.svg": 396,
	"./icons-square-corners": 397,
	"./icons-square-corners.svg": 397,
	"./icons-support": 398,
	"./icons-support.svg": 398,
	"./icons-toggle-close": 306,
	"./icons-toggle-close.svg": 306,
	"./icons-toggle-open": 307,
	"./icons-toggle-open.svg": 307,
	"./icons-transcribe": 268,
	"./icons-transcribe.svg": 268,
	"./illustrations-transcription-processing": 308,
	"./illustrations-transcription-processing.svg": 308,
	"./indicator-right": 399,
	"./indicator-right.svg": 399,
	"./infinite": 317,
	"./infinite.svg": 317,
	"./installer": 400,
	"./installer.svg": 400,
	"./integrations": 279,
	"./integrations.svg": 279,
	"./loader": 401,
	"./loader.svg": 401,
	"./logo-visa": 402,
	"./logo-visa.jpeg": 402,
	"./logo@2x": 124,
	"./logo@2x-blue": 181,
	"./logo@2x-blue.png": 181,
	"./logo@2x.png": 124,
	"./logos-cloud-app-logomark-full-color": 269,
	"./logos-cloud-app-logomark-full-color.svg": 269,
	"./main-banner": 182,
	"./main-banner.png": 182,
	"./markers/m_0": 403,
	"./markers/m_0.svg": 403,
	"./markers/m_1": 404,
	"./markers/m_1.svg": 404,
	"./markers/m_2": 405,
	"./markers/m_2.svg": 405,
	"./markers/m_3": 406,
	"./markers/m_3.svg": 406,
	"./markers/m_4": 407,
	"./markers/m_4.svg": 407,
	"./markers/m_5": 408,
	"./markers/m_5.svg": 408,
	"./markers/m_6": 409,
	"./markers/m_6.svg": 409,
	"./markers/m_7": 410,
	"./markers/m_7.svg": 410,
	"./markers/m_8": 411,
	"./markers/m_8.svg": 411,
	"./markers/m_9": 412,
	"./markers/m_9.svg": 412,
	"./menu-bar": 413,
	"./menu-bar.svg": 413,
	"./microsoft_teams_logo": 414,
	"./microsoft_teams_logo.svg": 414,
	"./new_annotate/move": 415,
	"./new_annotate/move.svg": 415,
	"./onboarding/apple": 221,
	"./onboarding/apple.svg": 221,
	"./onboarding/bill": 183,
	"./onboarding/bill.svg": 183,
	"./onboarding/chrome": 222,
	"./onboarding/chrome.svg": 222,
	"./onboarding/download-arrow": 223,
	"./onboarding/download-arrow.svg": 223,
	"./onboarding/download-chrome": 224,
	"./onboarding/download-chrome.svg": 224,
	"./onboarding/download-drop": 225,
	"./onboarding/download-drop.svg": 225,
	"./onboarding/download-mac": 226,
	"./onboarding/download-mac.svg": 226,
	"./onboarding/download-windows_color": 227,
	"./onboarding/download-windows_color.svg": 227,
	"./onboarding/email": 184,
	"./onboarding/email.svg": 184,
	"./onboarding/hat-icon": 228,
	"./onboarding/hat-icon.svg": 228,
	"./onboarding/icons-check": 138,
	"./onboarding/icons-check.svg": 138,
	"./onboarding/icons-chrome": 229,
	"./onboarding/icons-chrome.svg": 229,
	"./onboarding/icons-download": 185,
	"./onboarding/icons-download.svg": 185,
	"./onboarding/icons-extension": 186,
	"./onboarding/icons-extension.svg": 186,
	"./onboarding/icons-mac-os-app": 122,
	"./onboarding/icons-mac-os-app.png": 122,
	"./onboarding/icons-record": 187,
	"./onboarding/icons-record.svg": 187,
	"./onboarding/in-browser-icon": 230,
	"./onboarding/in-browser-icon.svg": 230,
	"./onboarding/installer": 231,
	"./onboarding/installer.svg": 231,
	"./onboarding/menu-bar": 232,
	"./onboarding/menu-bar.svg": 232,
	"./onboarding/start": 188,
	"./onboarding/start.svg": 188,
	"./onboarding/windows": 233,
	"./onboarding/windows.svg": 233,
	"./parallax": 416,
	"./parallax.jpg": 416,
	"./pattern": 189,
	"./pattern-2": 190,
	"./pattern-2.png": 190,
	"./pattern-4": 191,
	"./pattern-4.png": 191,
	"./pattern.png": 189,
	"./plus": 417,
	"./plus-small": 418,
	"./plus-small.svg": 418,
	"./plus.svg": 417,
	"./prize": 419,
	"./prize.svg": 419,
	"./prize@2x": 125,
	"./prize@2x.png": 125,
	"./pro-badge": 234,
	"./pro-badge.svg": 234,
	"./pro-ribbon": 103,
	"./pro-ribbon.png": 103,
	"./pro-ribbon.svg": 578,
	"./pro@1x": 192,
	"./pro@1x.png": 192,
	"./pro@2x": 139,
	"./pro@2x.png": 139,
	"./pro@3x": 193,
	"./pro@3x.png": 193,
	"./pro_plan_icon": 194,
	"./pro_plan_icon.png": 194,
	"./salesforce": 195,
	"./salesforce.png": 195,
	"./seats-left": 420,
	"./seats-left.svg": 420,
	"./slack-icon": 196,
	"./slack-icon.png": 196,
	"./slack_logo": 270,
	"./slack_logo.svg": 270,
	"./social-proof-image": 271,
	"./social-proof-image.jpeg": 271,
	"./spinner": 62,
	"./spinner.svg": 62,
	"./star_active": 421,
	"./star_active.svg": 421,
	"./star_default": 422,
	"./star_default.svg": 422,
	"./star_hover": 423,
	"./star_hover.svg": 423,
	"./start": 424,
	"./start.svg": 424,
	"./team": 272,
	"./team-3": 425,
	"./team-3.jpg": 425,
	"./team.svg": 272,
	"./team@2x": 140,
	"./team@2x.png": 140,
	"./team_plan_icon": 148,
	"./team_plan_icon.png": 148,
	"./team_sidebar": 197,
	"./team_sidebar.png": 197,
	"./thumbnail": 198,
	"./thumbnail.png": 198,
	"./upload-arrow": 426,
	"./upload-arrow.svg": 426,
	"./upload-cloud": 427,
	"./upload-cloud.svg": 427,
	"./upload-copy": 199,
	"./upload-copy.png": 199,
	"./upload-copy@2x": 200,
	"./upload-copy@2x.png": 200,
	"./upload-copy@3x": 201,
	"./upload-copy@3x.png": 201,
	"./upload-drop": 428,
	"./upload-drop.svg": 428,
	"./video-thumbnail": 202,
	"./video-thumbnail.png": 202,
	"./video-trim": 429,
	"./video-trim-active": 430,
	"./video-trim-active.svg": 430,
	"./video-trim.svg": 429,
	"./view-grid": 431,
	"./view-grid-active": 432,
	"./view-grid-active.svg": 432,
	"./view-grid.svg": 431,
	"./view-list": 433,
	"./view-list-active": 434,
	"./view-list-active.svg": 434,
	"./view-list.svg": 433,
	"./windows": 435,
	"./windows.svg": 435,
	"./your_plan_badge@2x": 203,
	"./your_plan_badge@2x.png": 203,
	"./zendesk": 204,
	"./zendesk.png": 204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 521;